export default __webpack_public_path__ + "static/media/offer-1.37128663.webp";